import React from 'react';
import SideNavExtension from '../components/SideNav/SideNavExtension';

const LeftExtension = ({leftExtension, hidden, header}) => {
	return ( 
		<SideNavExtension header={header} hidden={hidden} left content={leftExtension} />
	 );
}

export default LeftExtension;